import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import { Button } from 'sarsaparilla';
import AddressEdit from '../../containers/StewardAssetEditPage/AddressEdit';
import { AddressDefaults, AddressProps } from '../../props/address';

import pageStyles from '../../containers/StewardAssetEditPage/StewardAssetEditPage.scss';
import styles from './AddressesTab.scss';

const propTypes = {
  value: PropTypes.shape({
    addresses: PropTypes.arrayOf(AddressProps)
  }),
  addressType: PropTypes.string
};

const defaultProps = {
  value: {}
};

export default class AddressesTab extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      addresses: this.props.value.addresses
    };

    this.addAddress = this.addAddress.bind(this);
    this.removeAddress = this.removeAddress.bind(this);
  }

  addAddress() {
    const address = { ...AddressDefaults, _key: uniqueId('address-') };

    this.setState((prevState) => ({ ...prevState, addresses: [...prevState.addresses, address] }));
  }

  removeAddress(key) {
    this.setState((prevState) => ({
      ...prevState,
      addresses: prevState.addresses.filter((address) => address._key !== key)
    }));
  }

  render() {
    const { addressType } = this.props;
    const { addresses } = this.state;

    return (
      <div className={`${pageStyles['tab-body']} ${styles['asset-addresses']}`}>
        {addresses.map((address) => (
          <AddressEdit
            key={address._key}
            value={address}
            addressType={addressType}
            onRemove={this.removeAddress} />
        ))}
        <Button onClick={this.addAddress}>
          Add Address
        </Button>
      </div>
    );
  }
}

AddressesTab.propTypes = propTypes;
AddressesTab.defaultProps = defaultProps;
